

export interface PersonInterface {
    id: string;
    owner_id: string;
    second_owner_id: string;
    parent_id: string;
    level: number;
    name: string;
    latin_name: string;
    start_of_family_name: string;
    birthdate: Date;
    deathdate: Date;
    notes: string;
    lastupdate: Date;
    mother_name: string;
    mother_id: string;
    country_id: string;
    city_id: string;
    rootClan_id: string;
    rootClan_name: string;
    gender: number;
  }

  export class DefaultPersonTable implements PersonInterface {
    id = '';
    owner_id = '';
    second_owner_id = '';
    parent_id = '';
    level = 0;
    name = '';
    latin_name = '';
    start_of_family_name = '';
    birthdate = new Date();
    deathdate = new Date();
    notes = '';
    lastupdate = new Date();
    mother_name = '';
    mother_id = '';
    country_id = '';
    city_id = '';
    rootClan_id = '';
    rootClan_name = '';
    gender = 1;
  
    constructor() {
      // You can provide default values or leave them as is
    }

  }